(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-comparison"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeComparison = (root) => {
      if (!root || root.dataset.comparisonInitialized === 'true') return;

      const track = root.querySelector('[data-comparison-track]');
      const previousButton = root.querySelector('[data-comparison-previous]');
      const nextButton = root.querySelector('[data-comparison-next]');
      if (!track || !previousButton || !nextButton) return;

      const updateControls = () => {
        const canScroll = track.scrollWidth > track.clientWidth + 2;
        previousButton.hidden = !canScroll;
        nextButton.hidden = !canScroll;
        previousButton.disabled = !canScroll || track.scrollLeft <= 2;
        nextButton.disabled = !canScroll || track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };

      const scrollTrack = (direction) => {
        const amount = Math.max(track.clientWidth * 0.72, 220);
        track.scrollBy({ left: amount * direction, behavior: 'smooth' });
      };

      previousButton.addEventListener('click', () => scrollTrack(-1));
      nextButton.addEventListener('click', () => scrollTrack(1));
      track.addEventListener('scroll', updateControls, { passive: true });

      if ('ResizeObserver' in window) {
        new ResizeObserver(updateControls).observe(track);
      } else {
        window.addEventListener('resize', updateControls);
      }

      root.dataset.comparisonInitialized = 'true';
      updateControls();
    };

    const initializeAllComparisons = (scope = document) => {
      scope.querySelectorAll('[data-product-comparison]').forEach(initializeComparison);
    };

    initializeAllComparisons();
    document.addEventListener('shopify:section:load', (event) => initializeAllComparisons(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
